module.exports = __webpack_public_path__ + "a64113bb842f53db0459272c8f46a8ff.png";